import { API_DICTIONARY, HTTP_METHODS } from '../../constants'
import Fetcher from 'services/Fetcher'
import { TNotificationsSetup } from './types'

const fetcher = new Fetcher({})

export const getNotificationsSetupRequest = async () =>
  fetcher.request<unknown, TNotificationsSetup>({
    url: `${API_DICTIONARY.USERS}${API_DICTIONARY.CURRENT}${API_DICTIONARY.NOTIFICATIONS}`,
    method: HTTP_METHODS.GET
  })

export const updateNotificationsSetupRequest = async (
  data: TNotificationsSetup
) =>
  fetcher.request<unknown, TNotificationsSetup>({
    url: `${API_DICTIONARY.USERS}${API_DICTIONARY.CURRENT}${API_DICTIONARY.NOTIFICATIONS}`,
    method: HTTP_METHODS.PUT,
    data
  })
